// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"83e338eb","599":"045882dc","631":"8cfc119c","653":"49c9b68c","731":"1c097361","742":"f5e9ca20","787":"b5584ebf","921":"10b05d50","975":"8c9daaee"}[chunkId] + ".chunk.js";
};